<template>
<div class="nkn-developer">
  <div class="containers">
    <div class="nkn-container">
      <developer-client-intro></developer-client-intro>
    </div>
    <div class="nkn-container">
      <developer-core-tech></developer-core-tech>
    </div>
    <developer-dapp></developer-dapp>
    <div class="nkn-container">
      <developer-resources></developer-resources>
    </div>
    <!--<div class="nkn-container">
      <about-roadmap></about-roadmap>
    </div>-->
  </div>
</div>
</template>

<script>
import DeveloperClientIntro from '@/components/developer/nknClientIntro'
import DeveloperDapp from '@/components/developer/nkndApp'
import DeveloperResources from '@/components/developer/nknResources'
import DeveloperCoreTech from '@/components/developer/nknCoreTech'
import AboutRoadmap from '@/components/about/nknRoadmap'
export default {
  components: {
    DeveloperClientIntro,
    DeveloperDapp,
    DeveloperResources,
    DeveloperCoreTech,
    AboutRoadmap
  },
  metaInfo() {
    if (this.$i18n.locale === 'zh') {
      return {
        title: '开发者门户',
        // titleTemplate: '%s - by vue-meta',
        htmlAttrs: {
          lang: this.$i18n.locale
        },
        attribute: '',
        meta: [
          {name: 'keywords', content: 'NKN,nkn,P2P,Network,BlockChain'},
          {once: true,
            name: 'description',
            content: '技术介绍，开发工具SDK，应用实例和其他开发者资源。'
          }
        ]
      }
    } else {
      return {
        title: 'Introduction for Developers | The New Kind of Network',
        // titleTemplate: '%s - by vue-meta',
        htmlAttrs: {
          lang: this.$i18n.locale
        },
        meta: [
          {name: 'keywords', content: 'NKN,nkn,P2P,Network,BlockChain'},
          {once: true,
            name: 'description',
            content: 'Watch our intro to NKN videos and read more about our core technology, DApp examples, platform services, bounty programs, and developer resources.'
          }
        ]
      }
    }

  }
}
</script>

<style lang="scss" scoped>
.nkn-developer {
  .containers {
    width: 100%;
    padding: 0;
    .nkn-container:nth-child(even) {
      background-color: #f9faff;
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/DeveloperPortal.vue